export default __webpack_public_path__ + "static/phone-screen-50af251db3013d02573021ab5079eb79.webp";